import React, { Fragment, useState } from "react";

import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import HomeIcon from "@mui/icons-material/Home";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Link } from "react-router-dom";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import NavItem from "./NavItem";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { useSelector } from "react-redux";

const LeftSidebar = ({ menuActive, onClick }) => {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const [openMenu, setOpenMenu] = useState(null);

  const handleToggleMenu = (menuKey) => {
    setOpenMenu((prevMenu) => (prevMenu === menuKey ? null : menuKey));
  };

  const menuItems = loggedUserReducer?.loggedUser?.menus;

  const location = window.location.pathname;

  return (
    <Fragment>
      <div
        className={`sidebar-left-content-icons-holder ${
          menuActive && "active"
        }`}
      >
        <div className="sidebar-left-icons-list d-flex flex-column align-items-center">
          <div
            className={`sidebar-left-icon-item ${
              location != "/chat" && "active"
            }`}
          >
            <div className="d-flex flex-column align-items-center">
              <Link to={"/"}>
                <HomeIcon />{" "}
                <div className="sidebar-left-icon-item-text">Home</div>
              </Link>
            </div>
          </div>
          <div
            className={`sidebar-left-icon-item ${
              location == "/chat" && "active"
            }`}
          >
            <Link to="/chat">
              <div className="circle-icon-item"></div>
              <div className="d-flex flex-column align-items-center">
                <ForumOutlinedIcon />{" "}
                <div className="sidebar-left-icon-item-text">Chat</div>
              </div>
            </Link>
          </div>
          {/* <div className="sidebar-left-icon-item">
            <div className="d-flex flex-column align-items-center">
              <NotificationsOutlinedIcon />{" "}
              <div className="sidebar-left-icon-item-text">Activity</div>
            </div>
          </div> */}
          {/* <div className="sidebar-left-icon-item">
            <div className="d-flex flex-column align-items-center">
              <SettingsOutlinedIcon />{" "}
              <div className="sidebar-left-icon-item-text">Settings</div>
            </div>
          </div>
          <div className="sidebar-left-icon-item">
            <div className="d-flex flex-column align-items-center">
              <MoreHorizOutlinedIcon />{" "}
              <div className="sidebar-left-icon-item-text">More</div>
            </div>
          </div> */}
        </div>
      </div>
      <div className={`sidebar-main-content ${menuActive && "active"}`}>
        <div className="navbar-brand-box">
          <div href="#0" className="logo logo-light">
            <span className="logo-lg">
              <img
                src="/images/login-logo3.png"
                alt="LG"
                className="img-fluid"
              />
            </span>
          </div>
        </div>
        <ul className="navbar-nav" id="navbar-nav">
          {menuItems?.map((item, key) => (
            <NavItem
              item={item}
              key={key}
              onClick={onClick}
              openMenu={openMenu}
              handleToggleMenu={handleToggleMenu}
            />
          ))}
        </ul>
      </div>
    </Fragment>
  );
};

export default LeftSidebar;
